import { render, staticRenderFns } from "./UpdateAddressForm.vue?vue&type=template&id=d8450ad0&scoped=true"
import script from "./UpdateAddressForm.vue?vue&type=script&lang=ts"
export * from "./UpdateAddressForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8450ad0",
  null
  
)

export default component.exports